import { useState } from 'react';

export default function useHandlePaymentSelection() {
  const [paymentType, setPaymentType] = useState('creditCard');
  const handleOnSelect = (e: any) => {
    setPaymentType(e.target.id);
  };
  return {
    paymentType,
    handleOnSelect,
  };
}
